/**
 * 拍法 taxonomy 查询的单一入口(0924 车 C 起按调性档分缓存)。
 *
 * ★为什么收成一个 hook:创建页有六处读 taxonomy(拍法卡墙 / 联动卡 / 时长行 / 画面层 / 摘要面板 / 页面本体),
 *   此前各自手写同一个 `["video","creative-taxonomy"]` queryKey。调性档进来之后 key 要带 register
 *   —— 六处各改一遍必有一处漏掉,漏掉的那处会读到另一档的卡墙/默认牌。
 * ★register 随 query 发给 ai(`?register=`,query 名与 C-ai 对齐);luxury 档 ai 会优先推荐质感揭示 /
 *   佩戴时刻 / 匠心工艺 / 礼赠时刻。缺省按 hardsell(与 ai 缺省一致)。
 */
import { useQuery } from "@tanstack/react-query";

import { videoService } from "../api/videoService";
import type { ToneRegister } from "./toneRegister";

export function creativeTaxonomyQueryKey(register: ToneRegister | null | undefined) {
  return ["video", "creative-taxonomy", register ?? "hardsell"] as const;
}

export function useCreativeTaxonomy(
  register: ToneRegister | null | undefined,
  opts: { enabled?: boolean } = {}
) {
  const reg = register ?? "hardsell";
  return useQuery({
    queryKey: creativeTaxonomyQueryKey(reg),
    queryFn: () => videoService.getCreativeTaxonomy(reg),
    staleTime: Infinity,
    retry: 1,
    ...(opts.enabled === undefined ? {} : { enabled: opts.enabled }),
  });
}
